// extracted by mini-css-extract-plugin
export default {"productList":"mfb2OBRD4SOUccFL9wux-ProductBrandProductList-productList"};